import { FC, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Menu from 'components/menu/Menu';

import logo from 'assets/logo.svg';
import classNames from 'classnames';

const renderEnvTitle = () => {
  switch (window.location.hostname) {
    case 'u-app.testraa.se':
    case 'u-int-app.testraa.se':
      return 'Utvecklingsmiljö';
    case 's-app.testraa.se':
    case 's-int-app.testraa.se':
      return 'Systemtestmiljö';
    case 'a-app.testraa.se':
    case 'a-int-app.testraa.se':
      return 'Acceptanstestmiljö';
    case 'v-app.testraa.se':
    case 'v-int-app.testraa.se':
      return 'Verifikations-/Utbildningsmiljö';
    default:
      return '';
  }
};

const Topbar: FC = () => {
  const topbarRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [showMenu, setShowMenu] = useState<boolean>(false);

  const location = useLocation();

  return (
    <>
      <header
        id="topbar"
        ref={topbarRef}
        className="tw-top-0 tw-box-border tw-flex tw-h-20 tw-w-full tw-items-center tw-justify-between tw-border-b tw-border-raa-gray-3 tw-p-2 md:tw-p-4"
      >
        <Link to="/" className="tw-raa-button-focus tw-block tw-h-10" aria-label="Gå till startsidan">
          <img src={logo} alt="logotyp" className="tw-h-full" />
        </Link>

        {window.location.hostname.includes('testraa.se') && (
          <p className="tw-pointer-events-none tw-absolute tw-left-12 tw-right-0 tw-top-2 tw-uppercase tw-text-raa-green md:tw-left-0 md:tw-text-center">
            <span className="raa-icon-info tw-mr-1" />
            {renderEnvTitle()}
          </p>
        )}

        {location.pathname === '/' && <h1 className="tw-sr-only">Bebyggelseregistret - start</h1>}

        <nav className="tw-flex tw-justify-end">
          <Link
            to={'/sok-bebyggelseobjekt'}
            className="raa-button-focus tw-ml-2 tw-mr-2 tw-cursor-pointer tw-select-none tw-text-size-1.75 tw-text-raa-orange hover:tw-text-raa-orange-hover md:tw-ml-0"
          >
            <span className="tw-flex tw-flex-col tw-items-center">
              <span aria-hidden="true" className="tw-text-header raa-icon-search" />
              <span className="tw-text-size-0.813 tw-font-semibold tw-uppercase">Sök</span>
            </span>
          </Link>

          <button
            aria-controls="meny"
            aria-expanded={showMenu}
            aria-label="Öppna meny"
            ref={buttonRef}
            className="raa-button-focus tw-ml-2 tw-cursor-pointer tw-select-none tw-text-size-1.75 tw-text-raa-orange hover:tw-text-raa-orange-hover"
            onClick={() => setShowMenu(!showMenu)}
          >
            <span className="tw-flex tw-flex-col tw-items-center">
              <span
                aria-hidden="true"
                className={classNames('tw-text-header', {
                  'raa-icon-menu': !showMenu,
                  'raa-icon-close': showMenu
                })}
              />
              <span className="tw-text-size-0.813 tw-font-semibold tw-uppercase">meny</span>
            </span>
          </button>

          <Menu
            key="menu"
            open={showMenu}
            setShowMenu={setShowMenu}
            triggerRef={buttonRef}
            parent={topbarRef}
            onOutsideClick={() => setShowMenu(false)}
          />
        </nav>
      </header>
    </>
  );
};

export default Topbar;
